module.exports = __webpack_public_path__ + "img/shopping-cart-hover.74436a3.png";